<template>
  <div id="app">
    <app-layout
      v-if="isInnerPage"
      :title="title"
    >
      <div
        class="complate-logo"
        slot="logo"
      >
        <img
          src="@/assets/images/Logo.png"
          alt="logo"
        >
      </div>
      <div
        class="AppTopBar"
        slot="title"
      >
        <UserBox />
        <!-- <el-button
          class="recharge-btn"
          @click="goRechargePage"
          type="primary"
        >充值</el-button> -->
        <IconMenus
          :routers="allRoutes"
          :dashboardVisiable="dashboardVisiable"
          :toggleFastLink="toggleFastLink"
          :selectRouteMenu="selectRouteMenu"
        />
      </div>
      <template v-if="dashboardVisiable">
        <router-view
          class="body-container"
          slot="container"
        />
      </template>
      <template v-else>
        <template slot="nav">
          <CollectMenu
            v-if="showFastLink"
            :routers="route"
          />
          <sidebar-nav
            v-else-if="showSelected"
            :routers="selectedRoute"
          />
          <sidebar-nav
            v-else
            :routers="route"
          />
        </template>
        <router-view v-if="routerDone" />
        <div
          class="loading-container"
          v-else
          v-loading="!routerDone"
        ></div>
      </template>
    </app-layout>
    <router-view v-else />
    <RechargePayDialog
      :visible.sync="dialogPayVisible"
      :resetDialog="resetPayDialog"
      :selected="rechargePayData"
      :submitUpdateHandle="payHandle"
      :cancelHandle="resetPayDialog"
      :billTypeOptions="billTypeOptions"
      :showPayInfoDialog="showPayInfoDialog"
      :showDetailDialog="showDetailDialog"
      :showDetailButton="showDetailButton"
    />

    <PayInfoDialog :visible.sync="dialogPayInfoVisible" />

    <DetailDialog
      :visible.sync="dialogDetailVisible"
      :resetDialog="resetDetailDialog"
      :cancelHandle="resetDetailDialog"
      :listData="detailList"
      :fetchPlatformMonthList="fetchPlatformMonthList"
    />
  </div>
</template>

<script>
import UserBox from './containers/layout/components/UserBox';
import IconMenus from './containers/layout/IconMenu/IconMenu';
import CollectMenu from './containers/layout/Collect/Collect';
import { mapGetters, mapActions } from 'vuex';
import { getStorageData, setStorageData } from '@/utils/auth';
import { STSTEM_STATE_KEY } from '@/config';
import { getMenuDataByCode } from '@/utils/route';
import RechargePayDialog from './components/RechargePayDialog/RechargePayDialog';
import {
  rechargeOrder,
  checkOrderState,
  fetchRechargeOptions,
  fetchPlatformMonthList,
} from './api/platform/platform';
import PayInfoDialog from './components/RechargePayDialog/PayInfoDialog';
import DetailDialog from './components/RechargePayDialog/DetailDialog';
import QRCode from 'qrcode';

let timer = null;

export default {
  name: 'App',
  components: {
    UserBox,
    IconMenus,
    CollectMenu,
    RechargePayDialog,
    PayInfoDialog,
    DetailDialog,
  },
  props: {
    route: {
      type: Array,
      default: () => [],
    },
    allRoutes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const { selectedRoute, showFastLink, showSelected } = this.loadRouteState();
    return {
      title: '',
      selectedRoute: selectedRoute,
      routerDone: false,
      isInnerPage: false,
      showFastLink: showFastLink,
      showSelected: showSelected,
      dialogPayVisible: false,
      rechargePayData: this.initSelected(),
      billTypeOptions: [
        { value: '0', label: '不要发票' },
        { value: '1', label: '普通发票' },
        { value: '2', label: '专用发票' },
      ],
      dialogPayInfoVisible: false,
      dialogDetailVisible: false,
      showDetailButton: false,
      detailList: [],
    };
  },
  computed: {
    ...mapGetters(['whiteList', 'asyncRoutes']),
    dashboardVisiable() {
      return this.$route.name === 'dashboard';
    },
    // defaultRoute() {
    //   if (this.route && this.route.length) {
    //     let item = this.route.find(
    //       item => item.children && item.children.length
    //     );
    //     if (item) {
    //       return [this.route[0], item];
    //     } else {
    //       return [this.route[0]];
    //     }
    //   }
    //   return [];
    // },
  },
  created() {
    console.log('in created');
    // window['checkPayDialog'] = this.checkPayDialog;
    window['showPayDetailDialog'] = this.showDetailDialog;
  },
  mounted() {
    if (this.$route.meta && this.$route.meta.store) {
      this.showComponents(this.$route.meta.store);
    } else {
      this.showComponents();
    }
    this.title = document.title;
    let item = this.asyncRoutes.find(item => item.menuCode === '0169');
    if (item && item.meta.btns['0001']) {
      this.showDetailButton = true;
    }
  },
  watch: {
    route(newVal) {
      this.getFeedbackPage();
    },
    $route(newVal) {
      this.routerDone = false;
      if (newVal.meta && newVal.meta.store) {
        this.showComponents(newVal.meta.store);
      } else {
        this.showComponents();
      }
    },
  },
  methods: {
    ...mapActions([
      'updateFeedbackPage',
      'updateWarnningPage',
      'updateRechargePage',
    ]),
    initSelected() {
      return {
        createAt: '',
        giveBalance: undefined,
        id: undefined,
        operateId: undefined,
        operateName: '',
        rechargeId: undefined,
        rechargeType: '2',
        rechargeBalance: undefined,
        refundRechargeBalance: undefined,
        refundGiveBalance: undefined,
        updateAt: '',
        payQrUrl: '',
        orderNum: '',
        billType: '0',
        rechargeConfigs: [],
        isSkip: undefined,
        payTimeLimit: undefined,
        isAgree: false,
      };
    },
    showComponents(store) {
      this.isInnerPage =
        this.whiteList.indexOf(this.$route.path) !== -1 ? false : true;
      if (store) {
        store.install(this.$store);
        this.$nextTick(vm => {
          this.routerDone = true;
        });
      } else {
        this.routerDone = true;
      }
    },
    toggleFastLink(entity) {
      if (entity) {
        this.$router.push({
          path: '/',
        });
        this.showFastLink = entity;
      } else {
        this.showFastLink = entity;
        this.showSelected = false;
      }
      this.saveRouteState();
    },
    selectRouteMenu(routes) {
      this.selectedRoute = [this.route[0], ...routes];
      this.showSelected = true;
      this.showFastLink = false;
      this.saveRouteState();
    },
    saveRouteState() {
      const { selectedRoute, showFastLink, showSelected } = this;
      setStorageData(
        STSTEM_STATE_KEY,
        JSON.stringify({
          selectedRoute,
          showFastLink,
          showSelected,
        })
      );
    },
    loadRouteState() {
      let dataStr = getStorageData(STSTEM_STATE_KEY);
      if (dataStr) {
        let data = JSON.parse(dataStr);
        return data;
      } else {
        return {
          selectedRoute: [],
          showFastLink: false,
          showSelected: false,
        };
      }
    },
    getFeedbackPage() {
      let feedbackCode = process.env.VUE_APP_FEEDBACK_MENU_CODE;
      let feedbackMenu = getMenuDataByCode(this.route, feedbackCode);
      let warnningCode = process.env.VUE_APP_WARNNING_MENU_CODE;
      let warnningMenu = getMenuDataByCode(this.route, warnningCode);

      if (feedbackMenu) {
        this.updateFeedbackPage(feedbackMenu.name);
      }
      if (warnningMenu) {
        this.updateWarnningPage(warnningMenu.name);
      }
    },
    goRechargePage() {
      let rechargeCode = process.env.VUE_APP_RECHARGE_CODE;
      let rechargeMenu = getMenuDataByCode(this.route, rechargeCode);
      if (rechargeMenu) {
        this.updateRechargePage(rechargeMenu.name);
        this.$router.push({ name: rechargeMenu.name });
      } else {
        this.$message.error('无页面权限');
      }
    },
    checkPayDialog(operateId, operateName) {
      this.rechargePayData = {
        ...this.rechargePayData,
        operateId,
        operateName,
      };
      fetchRechargeOptions({
        data: { operateId: operateId, position: 2, type: 2 },
      })
        .then(res => {
          const {
            isSkip,
            payTimeLimit,
            rechargeConfigs,
            rechargeBalance,
            giveBalance,
          } = res;
          this.rechargePayData = {
            ...this.rechargePayData,
            rechargeConfigs,
            giveBalance,
            rechargeBalance,
            isSkip,
            payTimeLimit,
          };
          console.log('rechargeBalance', rechargeBalance);
          if (rechargeBalance > 0) {
            this.dialogPayVisible = true;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    resetPayDialog(done) {
      if (this.rechargePayData.isSkip) {
        timer && clearInterval(timer);
        this.rechargePayData = this.initSelected();
        done && typeof done == 'function'
          ? done()
          : (this.dialogPayVisible = false);
      }
    },
    validatePay() {
      if (!this.rechargePayData.isAgree) {
        this.$message.error('请同意条款');
        return;
      }
      if (!this.rechargePayData.rechargeType) {
        this.$message.error('请选择充值方式');
        return;
      }
      return true;
    },
    payHandle() {
      if (!this.validatePay()) return;
      rechargeOrder({
        data: {
          isAgree: 1,
          operateId: this.rechargePayData.operateId,
          operateName: this.rechargePayData.operateName,
          rechargeId: this.rechargePayData.rechargeId,
          rechargeType: this.rechargePayData.rechargeType,
          type: 2,
          billType: this.rechargePayData.billType,
        },
      })
        .then(res => {
          const { payQrUrl, orderNum } = res;
          const canvasDom = document.getElementById('PayQRcode');
          this.rechargePayData.payQrUrl = payQrUrl;
          this.rechargePayData.orderNum = orderNum;
          QRCode.toCanvas(
            canvasDom,
            payQrUrl,
            {
              margin: 1,
              width: 200,
            },
            error => {
              if (error) {
                console.error(error);
                return;
              }
              console.log('success!');
              timer = setInterval(() => {
                console.log('in setInterval');
                checkOrderState({
                  data: { orderNum: this.rechargePayData.orderNum },
                })
                  .then(res => {
                    const { rechargeState } = res;
                    if (rechargeState === '1') {
                      this.resetPayDialog();
                      this.fetchList();
                      this.$message.success(res.msg || '操作成功');
                    }
                  })
                  .catch(err => {
                    console.log(err);
                  });
              }, 3000);
            }
          );
        })
        .catch(err => {
          console.log(err);
        });
    },
    showPayInfoDialog() {
      this.dialogPayInfoVisible = true;
    },
    showDetailDialog() {
      fetchPlatformMonthList({
        data: {
          operateId: this.rechargePayData.operateId,
        },
      })
        .then(res => {
          const { list } = res.data;
          this.detailList = list;
          this.dialogDetailVisible = true;
        })
        .catch(err => {
          console.log(err);
        });
    },
    fetchPlatformMonthList(entity) {
      fetchPlatformMonthList({
        data: {
          ...entity,
          operateId: this.rechargePayData.operateId,
        },
      })
        .then(res => {
          const { list } = res.data;
          this.detailList = list;
        })
        .catch(err => {
          console.log(err);
        });
    },
    resetDetailDialog(done) {
      this.detailList = [];
      done && typeof done == 'function'
        ? done()
        : (this.dialogDetailVisible = false);
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/variables.scss';
.AppTopBar {
  flex: 1;
  display: flex;
  justify-content: space-between;
  .recharge-btn {
    align-self: center;
  }
}
.loading-container {
  margin: 50px;
}
.left-box {
  transition: all 0.48s;
}
.topTitle {
  .complate-logo {
    width: 274px;
    height: 24px;
    margin-left: 28px;
  }
  .com-title {
    display: none;
  }
}
.record-List {
  .record-Item {
    display: inline-block;
    min-width: 100px;
  }
}
@media screen and (max-width: $bigScreenWidth) {
  .topTitle {
    .complate-logo {
      width: 205px;
      height: 18px;
    }
  }
}
</style>
